import React from 'react';
import PropTypes from 'prop-types';

import AlertContextTitle from '../AlertContextTitle';
import AlertSinceDate from '../AlertSinceDate';

export default function AlertLeftBlock (props) {
  const { type } = props;

  return (
    <div className='alert-left-block'>
      {type === 'header' ?
        <AlertContextTitle {...props} /> :
        <AlertSinceDate {...props} />
      }
    </div>
  );
}

AlertLeftBlock.propTypes = {
  type: PropTypes.string.isRequired,
};
